<template>
  <div class="order-list-component">
    <div
      class="no-exchange-order"
      v-if="!list.length"
    >
      <div class="no-exchange-module">
        <img src="@/assets/images/order/no-exchange-order.png" />
        <p> 亲，您还没有订单哦！</p>
      </div>

    </div>
    <div v-else>
      <template v-for="(order, index) in list">
        <order-item
          :order="order"
          :key="index"
          @showPolicyDialog="showPolicyDialog"
          @getAgreement="getAgreement"
          @goPay="goPay"
          @cancelPay="cancelPay"
        />
      </template>
    </div>

    <agreement-dialog
      :visible.sync="dialogVisible"
      :version="version"
      :versions="versions"
      :studentId="studentId"
      :serialNumber="serialNumber"
    ></agreement-dialog>
    <policy-dialog
      :visible.sync="policyDialogVisible"
      :list='policyList'
      :versions="versions"
    >
    </policy-dialog>
    <address-dialog
      :visible.sync="addressDialogVisible"
      :defaultAddress="defaultAddress"
      @useDefaultAddress="useDefaultAddress"
    ></address-dialog>
    <!-- 页数显示 -->
    <slot></slot>
  </div>
</template>

<script>
import orderItem from './orderItem'
import agreementDialog from './agreementDialog'
import addressDialog from './addressDialog'
import policyDialog from './policyDialog'

export default {
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    orderItem, agreementDialog, policyDialog, addressDialog
  },
  data() {
    return {
      dialogVisible: false,
      policyDialogVisible: false,
      serialNumber:'',
      version: {}, // 点击协议时， 替换的version obj
      versions: [], // 点击新生政策时，替换的versions
      // orderStatus: '',
      studentId: '',
      addressDialogVisible: false,
      defaultAddress: {},
      orderId: '',
      policyList: []
    }
  },
  methods: {
    // 点击服务协议，弹框
    getAgreement(v, studentId, versions,serialNumber) {
      this.studentId = studentId
      this.version = v
      this.versions = versions
      this.serialNumber = serialNumber
      console.log('serialNumber', serialNumber)
      this.dialogVisible = true
    },
    // 政策详情
    showPolicyDialog(order) {
      this.versions = order.versions
      this.policyList = this.getPolicyList(order)
      this.policyDialogVisible = true
    },
    goPay(orderId, dataFlg, orderType, studentId, currency) {
      const data = {
        orderId,
        dataFlg,
        orderType,
        studentId,
        currency
      }
      this.checkOrder(data)
    },
    checkOrder({ orderId, dataFlg, orderType, studentId, currency }) {
      this.axios({
        method: 'post',
        url: '/gw/order-rest/api/order_rest/pay/check/status',
        params: { id: orderId, flg: dataFlg }
      }).then(res => {
        if (res.data.msg == 'OK') {
          this.$router.push({ name: currency === 'CNY' ? 'orderPay' : 'InternationalPay', params: { payOrderId: orderId, orderType, studentId } })
        } else {
          if (res.data.msg == 'ISBILL') {
            this.$alert('订单已拆分，暂时不可支付。请重试')
            this.$emit('getOrderList')
          } else if (res.data.msg == 'ISCHANGE') {
            this.$alert('订单状态已更新,不可支付')
            this.$emit('getOrderList')
          } else {
            this.$emit('getOrderList')
          }
        }
      })
    },
    // 点击“立即确认收货地址”
    sureAddress(studentId, orderId) {
      this.orderId = orderId
      this.axios({
        method: 'get',
        url: '/gw/order-rest/api/order_rest/customerAddress/family/defaultCustomerAddress/getByStudentId',
        params: {
          studentId,
          _timeStamp: new Date().getTime()
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.defaultAddress = res.data.data
          this.addressDialogVisible = true
        }
      })
    },
    // 确认使用默认收货地址
    useDefaultAddress(customerAddressId) {
      this.axios({
        method: 'post',
        url: '/gw/order-rest/api/order_rest/shipaddress/confirm',
        params: {
          customerAddressId,
          packOrderId: this.orderId
        }
      }).then(res => {
        if (res.data.code === 200 || res.data.code === 100010) {
          this.$emit('getOrderList')
        } else {
          this.$alert("设置地址失败请重试")
        }
      })
    },
    cancelPay({ id, old, deposit }) {
      this.$confirm({
        title: '温馨提示',
        content: '订单取消后无法恢复，相关购买优惠可能一并取消',
        cancelBtnText: "取消",
        sureBtnText: "确定"
      })
        .then(() => {
          this.axios({
            method: 'get',
            url: '/gw/order-rest/api/order_rest/packorder/cancel/id',
            params: {
              id,
              isOld: old,
              isDeposit: deposit
            }
          }).then(res => {
            if (res.data.code === 200) {
              this.$emit('getOrderList')
            } else {
              this.$alert(res.data.msg)
            }
          })
        })
        .catch(err => { });
    }
  }
}
</script>

<style lang="less" scoped>
.order-list-component {
  .no-exchange-order {
    text-align: center;
    .no-exchange-module {
      display: inline-block;
      margin: 50px auto 200px;
      p {
        margin-top: 20px;
        font-size: 18px;
        color: #b9b9b9;
      }
    }
  }
}
</style>
